module.exports = __webpack_public_path__ + "acb5ba48db6c8e60780d9b8781570eae.svg";